'use client';

import { styled } from '@mui/material';
import { CenteredContainer } from '@ianesthesie-kit/core';

export const EmptyLayout = styled(CenteredContainer)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
